import { Component } from 'react'
import { Choice, Code, CodeableConcepts, CodeableConcept, Components } from '../helpers'
import { GiMicroscope } from 'react-icons/gi'

import './resource.css'

class Observation extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div className={`Flip-Container`} onClick={() => this.handleJson()}><div className={`Res-Container Res-Condition${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.status && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.status && Code(this.props.resource.status)}</div>
                        </div>
                        <div className='Res-Icon-Big'><GiMicroscope /></div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.category && 'Classification'}</div>
                            <div className='Res-Title'>{this.props.resource.category && CodeableConcepts(this.props.resource.category)}</div>
                        </div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.code && 'Observation'}</div>
                        <div className='Res-Title'>{this.props.resource.code && CodeableConcept(this.props.resource.code)}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.valueCodeableConcept && 'Information'}</div>
                        <div className='Res-Title'>{this.props.resource.valueCodeableConcept && CodeableConcept(this.props.resource.valueCodeableConcept)}</div>
                    </div>
                    <div className='Res-row'>
                        <div className='Res-Detail Res-Content-Rev'>{(this.props.resource.effectiveDateTime || this.props.resource.effectivePeriod || this.props.resource.effectiveTiming || this.props.resource.effectiveInstant) && 'Observed'}</div>
                        {this.props.resource.effectiveDateTime && <div className='Res-Detail'>{Choice('DateTime', this.props.resource.effectiveDateTime)}</div>}
                        {this.props.resource.effectivePeriod && <div className='Res-Detail'>{Choice('Period', this.props.resource.effectivePeriod)}</div>}
                        {this.props.resource.effectiveTiming && <div className='Res-Detail'>{Choice('Timing', this.props.resource.effectiveTiming)}</div>}
                        {this.props.resource.effectiveInstant && <div className='Res-Detail'>{Choice('Instant', this.props.resource.effectiveInstant)}</div>}
                    </div>
                    <div className='Res-row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.issued && 'Issued'}</div>
                        {this.props.resource.issued && <div className='Res-Detail'>{Choice('Instant', this.props.resource.issued)}</div>}
                    </div>
                    <div className='Res-row'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{(this.props.resource.valueQuantity || this.props.resource.valueCodeableConcept || this.props.resource.valueString || this.props.resource.valueBoolean || this.props.resource.valueInteger || this.props.resource.valueRange || this.props.resource.valueRatio || this.props.resource.valueSampleData || this.props.resource.valueTime || this.props.resource.valueDateTime || this.props.resource.valuePeriod) && 'Value'}</div>
                        </div>
                        <div>
                            {this.props.resource.valueQuantity && <div className='Res-Title'>{Choice('Quantity', this.props.resource.valueQuantity)}</div>}
                            {this.props.resource.valueCodeableConcept && <div className='Res-Title'>{Choice('Quantity', this.props.resource.valueCodeableConcept)}</div>}
                            {this.props.resource.valueString && <div className='Res-Title'>{Choice('Quantity', this.props.resource.valueString)}</div>}
                            {this.props.resource.valueBoolean && <div className='Res-Title'>{Choice('Quantity', this.props.resource.valueBoolean)}</div>}
                            {this.props.resource.valueInteger && <div className='Res-Title'>{Choice('Quantity', this.props.resource.valueInteger)}</div>}
                            {this.props.resource.valueRange && <div className='Res-Title'>{Choice('Quantity', this.props.resource.valueRange)}</div>}
                            {this.props.resource.valueRatio && <div className='Res-Title'>{Choice('Quantity', this.props.resource.valueRatio)}</div>}
                            {this.props.resource.valueSampleData && <div className='Res-Title'>{Choice('Quantity', this.props.resource.valueSampleData)}</div>}
                            {this.props.resource.valueTime && <div className='Res-Title'>{Choice('Quantity', this.props.resource.valueTime)}</div>}
                            {this.props.resource.valueDateTime && <div className='Res-Title'>{Choice('Quantity', this.props.resource.valueDateTime)}</div>}
                            {this.props.resource.valuePeriod && <div className='Res-Title'>{Choice('Quantity', this.props.resource.valuePeriod)}</div>}
                        </div>
                    </div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.method && 'Method'}</div>
                            {this.props.resource.method && <div className='Res-Title'>{CodeableConcept(this.props.resource.method)}</div>}
                        </div>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.interpretation && 'Interpretation'}</div>
                            {this.props.resource.interpretation && <div className='Res-Title'>{CodeableConcepts(this.props.resource.interpretation)}</div>}
                        </div>
                    </div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.bodySite && 'Body Site'}</div>
                            {this.props.resource.bodySite && <div className='Res-Title'>{CodeableConcept(this.props.resource.bodySite)}</div>}
                        </div>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{(this.props.resource.component) && 'Results'}</div>
                            {this.props.resource.component && <div className='Res-Title'>{Components(this.props.resource.component)}</div>}
                        </div>
                    </div>
                </div>
            }
        </div></div>
    }
}

export default Observation